<template>
  <b-progress
    :value="valor"
    :max="100"
    :type="valor === 100 ? 'is-success' : 'is-primary'"
    show-value
    >{{ valor }}%</b-progress
  >
</template>
<script>
export default {
  name: 'EadProgresso',
  props: { valor: { type: Number, default: 0 } },
}
</script>
